import dynamicDialog from './DynamicDialog.vue'
import { i18n } from '~src/i18n'
import store from '~store/store'
import _ from 'lodash'
import { getVuetifyInstance } from '../vuetify'

export default {
  install(Vue) {
    const DynamicDialogConstructor = Vue.extend(dynamicDialog)
    let instance

    function destroyInstance() {
      instance.$destroy()
      if (instance.$el && instance.$el.parentNode) {
        instance.$el.parentNode.removeChild(instance.$el)
      }
      instance = null
    }

    Vue.prototype.$dynamicDialog = options => {
      if (options.readOnly === true) {
        _.each(options.fields, field => {
          field.readOnly = true
        })
      }
      if (instance) return

      const vuetify = getVuetifyInstance()

      instance = new DynamicDialogConstructor({
        store,
        i18n,
        vuetify,
        propsData: {
          title: options.title,
          fields: options.fields,
          value: options.value,
          icon: options.icon,
          maxWidth: options.maxWidth,
          readOnly: options.readOnly,
          persistent: options.persistent,
          buttons: options.buttons,
          saveLabel: options.saveLabel,
          saveIcon: options.saveIcon,
          validationFunction: options.validationFunction
        }
      })
      instance.$mount()
      document.body.appendChild(instance.$el)

      return new Promise((resolve, reject) => {
        instance.$on('save', payload => {
          destroyInstance()
          resolve(payload)
        })

        instance.$on('close', () => {
          destroyInstance()
          reject()
        })

        instance.open()
      })
    }

    Vue.prototype.$dynamicDialog.close = () => {
      if (instance) {
        instance.close()
      }
    }
  }
}
